import React, { createContext, useState, useEffect, useContext } from 'react';
import api from '../api/axiosConfig';
import AuthContext from './AuthContext';
import PushNotificationService from '../services/PushNotificationService';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showPanel, setShowPanel] = useState(false);

  const fetchUnreadCount = async () => {
    if (!user) return;
    try {
      const res = await api.get('/notifications/unread-count');
      setUnreadCount(res.data.count);
      // 다 읽었으면 알림함도 비운다. 런처의 숫자는 그 알림함이 세는 값이라,
      // 앱에서만 읽음 처리하면 아이콘에 숫자가 그대로 남는다.
      if (res.data.count === 0) {
        PushNotificationService.clearDelivered();
      }
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  };

  useEffect(() => {
    if (user) {
      fetchUnreadCount();
      const interval = setInterval(fetchUnreadCount, 60000);
      return () => clearInterval(interval);
    } else {
      setUnreadCount(0);
    }
  }, [user]);

  const openPanel = () => setShowPanel(true);
  const closePanel = () => setShowPanel(false);

  return (
    <NotificationContext.Provider value={{ unreadCount, fetchUnreadCount, openPanel, closePanel, showPanel }}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContext;
